import { render } from "./STFMFM02C27UpdatePropertModal.vue?vue&type=template&id=c5ab9dde&scoped=true"
import script from "./STFMFM02C27UpdatePropertModal.vue?vue&type=script&lang=js"
export * from "./STFMFM02C27UpdatePropertModal.vue?vue&type=script&lang=js"

import "./STFMFM02C27UpdatePropertModal.vue?vue&type=style&index=0&id=c5ab9dde&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ab9dde"]])

export default __exports__